import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface ICentralHeating {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  gasCentralHeating?: number | null;
  electricCentralHeating?: number | null;
  oilCentralHeating?: number | null;
  solidFuelCentralHeating?: number | null;
  otherCentralHeating?: number | null;
  noCentralHeating?: number | null;
}

export const defaultValue: Readonly<ICentralHeating> = {};
